import { Table as TableAD } from "antd";
import styled from "styled-components";

import { COLORS } from "../constants";

import { Table } from "./Table";

export const AdminTable = styled(Table)<{ isExpandable?: boolean }>`
  border: 1px solid ${COLORS.black8};
  overflow: auto;

  && .ant-table-header table thead tr {
    th {
      background: #ecf6ff;
      padding-left: 8px;
      color: #0054e6;
    }

    & th.ant-table-column-sort {
      background: #ecf6ff;
    }

    & th:hover {
      background: #cce9ff;
    }
  }

  &&& {
    .ant-table td {
      border-color: ${COLORS.black8};
      line-height: 1.3;
    }

    .ant-table-thead tr th {
      font-size: 14px;
      font-weight: 700;
      height: auto;
      padding: 10px 12px !important;
      background: rgb(248, 250, 255) !important;
    }

    .ant-table-thead tr th .ant-table-filter-trigger {
      display: none;
    }

    .ant-table-thead tr th:hover .ant-table-filter-trigger,
    .ant-table-thead tr th .ant-table-filter-trigger.ant-dropdown-open,
    .ant-table-thead tr th .ant-table-filter-trigger:has(.sort-icon-active) {
      display: flex;
    }

    .ant-table-thead tr th .ant-table-filter-column {
      justify-content: flex-start;

      .ant-table-column-title {
        flex-grow: 0;
        white-space: nowrap;
        flex-wrap: nowrap;
      }
    }

    .ant-table-tbody tr td {
      font-size: 14px;
      height: auto;
      padding: 8px 12px !important;

      &.center {
        text-align: center;
      }

      svg {
        flex-shrink: 0;
      }
    }

    .ant-table-tbody tr:last-of-type td {
      border: none !important;
    }
  }

  &&& {
    .ant-table .ant-table-tbody .ant-table-measure-row td {
      padding: 0 !important;
    }
  }
` as typeof TableAD;
